import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getProducts
} from "../../api/productApi";

import {
  getMaterials
} from "../../api/materialApi";

import {
  createBOM
} from "../../api/bomApi";

const BOMCreate = () => {

  const [products,setProducts] =
  useState([]);

  const [materials,setMaterials] =
  useState([]);

  const [form,setForm] =
  useState({

    product_id:"",
    output_quantity:1000

  });

  const [rows,setRows] =
  useState([
    {
      material_id:"",
      quantity:""
    }
  ]);

  useEffect(()=>{

    loadData();

  },[]);

  const loadData =
  async()=>{

    const productsRes =
    await getProducts();

    const materialsRes =
    await getMaterials();

    setProducts(
      productsRes.data.data || []
    );

    setMaterials(
      materialsRes.data.data || []
    );

  };

  const addRow =
  ()=>{

    setRows([
      ...rows,
      {
        material_id:"",
        quantity:""
      }
    ]);

  };

  const saveBOM =
  async(e)=>{

    e.preventDefault();

    await createBOM({

      ...form,

      materials:rows

    });

    alert(
      "BOM Saved"
    );

  };

  return(

    <MainLayout>

      <div className="card">

        <div className="card-header">

          <h5>
            Create BOM
          </h5>

        </div>

        <div className="card-body">

          <form
            onSubmit={saveBOM}
          >

            <div className="row mb-3">

              <div className="col-md-6">

                <label>
                  Product
                </label>

                <select
                  className="form-select"
                  value={
                    form.product_id
                  }
                  onChange={(e)=>
                    setForm({
                      ...form,
                      product_id:
                      e.target.value
                    })
                  }
                >

                  <option value="">
                    Select Product
                  </option>

                  {
                    products.map(
                      p=>(
                        <option
                          key={p.id}
                          value={p.id}
                        >
                          {p.product_name}
                        </option>
                      )
                    )
                  }

                </select>

              </div>

              <div className="col-md-6">

                <label>
                  Output Qty
                </label>

                <input
                  className="form-control"
                  value={
                    form.output_quantity
                  }
                  onChange={(e)=>
                    setForm({
                      ...form,
                      output_quantity:
                      e.target.value
                    })
                  }
                />

              </div>

            </div>

            <table className="table">

              <thead>

                <tr>

                  <th>
                    Material
                  </th>

                  <th>
                    Qty
                  </th>

                </tr>

              </thead>

              <tbody>

                {
                  rows.map(
                    (row,index)=>(
                      <tr
                        key={index}
                      >

                        <td>

                          <select
                            className="form-select"
                            onChange={(e)=>{

                              const updated =
                              [...rows];

                              updated[index]
                              .material_id =
                              e.target.value;

                              setRows(
                                updated
                              );

                            }}
                          >

                            <option>
                              Select
                            </option>

                            {
                              materials.map(
                                m=>(
                                  <option
                                    key={m.id}
                                    value={m.id}
                                  >
                                    {m.material_name}
                                  </option>
                                )
                              )
                            }

                          </select>

                        </td>

                        <td>

                          <input
                            className="form-control"
                            onChange={(e)=>{

                              const updated =
                              [...rows];

                              updated[index]
                              .quantity =
                              e.target.value;

                              setRows(
                                updated
                              );

                            }}
                          />

                        </td>

                      </tr>
                    )
                  )
                }

              </tbody>

            </table>

            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={addRow}
            >

              Add Material

            </button>

            <button
              className="btn btn-primary"
            >

              Save BOM

            </button>

          </form>

        </div>

      </div>

    </MainLayout>

  );

};

export default BOMCreate;